import toast from "react-hot-toast";
import { clientAPI } from "../client";

const getFileNameFromContentDisposition = (contentDisposition) => {
  if (!contentDisposition) return "";

  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1]);
  }

  const normalMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
  if (normalMatch?.[1]) {
    return normalMatch[1];
  }

  return "";
};

const downloadBlobFile = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = fileName || `bao-cao-kpi-${Date.now()}.xlsx`;
  document.body.appendChild(link);
  link.click();

  link.remove();
  window.URL.revokeObjectURL(url);
};

export const employeeKPICall = {
  exportEmployeeDetailKPI: async (param) => {
    try {
      const options = {};

      if (param?.code) options.code = param.code;
      if (param?.month) options.month = param.month;
      if (param?.year) options.year = param.year;

      const queryParams = new URLSearchParams(options).toString();

      const response = await clientAPI(
        "get",
        `/document/export/api/v2/msh/evaluations/sale-kpis/monthly/detail?${queryParams}`,
        {},
        {
          responseType: "blob",
        },
      );

      const blob = response?.data || response;

      const contentDisposition =
        response?.headers?.["content-disposition"] ||
        response?.headers?.get?.("content-disposition");

      const fileName =
        getFileNameFromContentDisposition(contentDisposition) ||
        `[${String(param?.month || "").padStart(2, "0")}_${param?.year || ""}][${
          param?.code || "UNKNOWN"
        }] Báo cáo KPI.xlsx`;

      downloadBlobFile(blob, fileName);

      return response;
    } catch (error) {
      console.error("Export KPI error:", error);

      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "Xuất file KPI thất bại.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });

      throw error;
    }
  },
};
